import { connect } from "react-redux";

const Loader = ({ loading, loadingMessage }) => {
    if (!loading) return null;

    return (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gray-200/80">
            <div className="flex flex-col items-center gap-4 max-w-[90%] text-center">

                {/* Spinner */}
                <div className="w-16 h-16">
                    <div className="w-full h-full rounded-full border-4 border-[#44288E] border-t-transparent border-r-transparent animate-spinDualRing"></div>
                </div>

                {/* Message
                {loadingMessage && (
                    <p className="text-sm font-medium text-gray-700 break-words max-w-md">
                        {loadingMessage}
                    </p>
                )} */}
            </div>
        </div>
    );
};


const mapStateToProps = (state) => ({
    loading: state.common.loading,
    loadingMessage: state.common.loadingMessage,
});

export default connect(mapStateToProps)(Loader);
